import { Venue } from "../types/venue.types"
import cardLocation from "../assets/images/location.png"
// Sample venues
export const venues : Venue[]= [
    {   
        id:6,
        title: "Zahrada Michelská",
        address: "Michelská 25, Praha 4",
        price: 8934,
        photo: cardLocation,
        type: "Outdoor",
        amountOfPeople: "50",
        description:
        `Zrekonstruovaný Pražský špejchar z 18. století v Praze 10 - Dubeč Vás překvapí jedinečnou atmosférou pro pořádání svateb, společenských a firemních akcí, nejen uvnitř budovy, ale i v rozlehlé zahradě a přilehlém parku.
        Naleznete zde velký sál, členitý ochoz, vybavenou kuchyňku, výtah. Spodní sál pojme celkem 150 osob a ochoz 75 osob.`,
        keywords: ["Mix", "Slané", "Studený", "bufet", "Jídlo", "Snack", "Snídaně", "Dopolední coffee break", "Odpolední coffee break", "Více porcí"]
    },
    {   
        id:7,
        title: "Zahrada Michelská",
        address: "Michelská 25, Praha 4",
        price: 8934,
        photo: cardLocation,
        type: "Outdoor",
        amountOfPeople: "50",
        description:
        `Zrekonstruovaný Pražský špejchar z 18. století v Praze 10 - Dubeč Vás překvapí jedinečnou atmosférou pro pořádání svateb, společenských a firemních akcí, nejen uvnitř budovy, ale i v rozlehlé zahradě a přilehlém parku.
        Naleznete zde velký sál, členitý ochoz, vybavenou kuchyňku, výtah. Spodní sál pojme celkem 150 osob a ochoz 75 osob.`,
        keywords: ["Mix", "Slané", "Studený", "bufet", "Jídlo", "Snack", "Snídaně", "Dopolední coffee break", "Odpolední coffee break", "Více porcí"]
    },
    {   
        id:8,
        title: "Zahrada Michelská",
        address: "Michelská 25, Praha 4",
        price: 8934,
        photo: cardLocation,
        type: "Outdoor",
        amountOfPeople: "50",
        description:
        `Zrekonstruovaný Pražský špejchar z 18. století v Praze 10 - Dubeč Vás překvapí jedinečnou atmosférou pro pořádání svateb, společenských a firemních akcí, nejen uvnitř budovy, ale i v rozlehlé zahradě a přilehlém parku.
        Naleznete zde velký sál, členitý ochoz, vybavenou kuchyňku, výtah. Spodní sál pojme celkem 150 osob a ochoz 75 osob.`,
        keywords: ["Mix", "Slané", "Studený", "bufet", "Jídlo", "Snack", "Snídaně", "Dopolední coffee break", "Odpolední coffee break", "Více porcí"]
    },
    {   
        id:9,
        title: "Zahrada Michelská",
        address: "Michelská 25, Praha 4",
        price: 8934,
        photo: cardLocation,
        type: "Outdoor",
        amountOfPeople: "50",
        description:
        `Zrekonstruovaný Pražský špejchar z 18. století v Praze 10 - Dubeč Vás překvapí jedinečnou atmosférou pro pořádání svateb, společenských a firemních akcí, nejen uvnitř budovy, ale i v rozlehlé zahradě a přilehlém parku.
        Naleznete zde velký sál, členitý ochoz, vybavenou kuchyňku, výtah. Spodní sál pojme celkem 150 osob a ochoz 75 osob.`,
        keywords: ["Mix", "Slané", "Studený", "bufet", "Jídlo", "Snack", "Snídaně", "Dopolední coffee break", "Odpolední coffee break", "Více porcí"]
    },
    {   
        id:10,
        title: "Zahrada Michelská",
        address: "Michelská 25, Praha 4",
        price: 8934,
        photo: cardLocation,
        type: "Outdoor",
        amountOfPeople: "50",
        description:
        `Zrekonstruovaný Pražský špejchar z 18. století v Praze 10 - Dubeč Vás překvapí jedinečnou atmosférou pro pořádání svateb, společenských a firemních akcí, nejen uvnitř budovy, ale i v rozlehlé zahradě a přilehlém parku.
        Naleznete zde velký sál, členitý ochoz, vybavenou kuchyňku, výtah. Spodní sál pojme celkem 150 osob a ochoz 75 osob.`,
        keywords: ["Mix", "Slané", "Studený", "bufet", "Jídlo", "Snack", "Snídaně", "Dopolední coffee break", "Odpolední coffee break", "Více porcí"]
    },
]